import MobileAppDevelopmentMobileView from './MobileAppDevelopmentMobileView/MobileAppDevelopmentMobileView'
import MobileAppDevelopmentDesktopView from "./MobileAppDevelopmentDesktopView/MobileAppDevelopmentDesktopView"
const MobileAppDevelopment = () => {
    return (
        <div>
            <MobileAppDevelopmentMobileView/>
            <MobileAppDevelopmentDesktopView/>
        </div>
    )
}

export default MobileAppDevelopment
